import { render, staticRenderFns } from "./schedulerWorkspace.vue?vue&type=template&id=af6d3f52&scoped=true"
import script from "./schedulerWorkspace.vue?vue&type=script&lang=js"
export * from "./schedulerWorkspace.vue?vue&type=script&lang=js"
import style0 from "./schedulerWorkspace.vue?vue&type=style&index=0&id=af6d3f52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6d3f52",
  null
  
)

export default component.exports